module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bIhTq"))).then(() => parcelRequire('1iHdE'));